import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/web/strives.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              TekRevol Strives On Delivering Value as a Premier Website
              Development Company
            </h2>
            <p>
              At TekRevol, our client-focused culture is fostered to deliver
              value to all our web design Dubai clients and other cities and
              counties of the region. Mobile web development solutions are in
              great demand in today’s fast-moving and competitive digital space.
              We build websites that function seamlessly on the web and perform
              flawlessly on mobile.
            </p>
            <p>
              Our commitment to serving clients is unparalleled and makes us
              stand out in the list of web development company Dubai. Our
              website development company Dubai is ever-ready to deliver great
              websites and cater to varying client requirements, delivering the
              ideal web experience. Get your website developed by an expert web
              development company and reap lifetime benefits.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's Take Your Brand Online
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
